// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA29BPQB3JJgpjrJs9URr90kF5SJ2LRymk",
    authDomain: "skilled-solutions.firebaseapp.com",
    projectId: "skilled-solutions",
    storageBucket: "skilled-solutions.appspot.com",
    messagingSenderId: "785417504990",
    appId: "1:785417504990:web:117b7d7515c5edd90d1a4f",
    measurementId: "G-CSJVBLXM86"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);


export {db, analytics};